import React from "react";
import './Header.css';
import optimizelogo from '../../images/Optimize-Global-Solutions.png';

function Header() {
  return (
    <div className="index-page">
      <header id="header" className="header d-flex align-items-center fixed-top">
<div className="header-div container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
          <a href="/" className="logo d-flex align-items-center">
            <img
              src={optimizelogo}
              alt=""
              style={{ height: "130px", width: "160px" ,marginTop:"15px",marginLeft:"25px"}}
            />
          </a>

          <nav id="navmenu" className="navmenu ms-auto">
            <ul>
              <li><a href="#hero" className="active">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#solutions">Solutions</a></li>
              <li><a href="#blog">Blog</a></li>
              <li><a href="#contact">Contact</a></li>

                </ul>

          </nav>

          <a className="btn-getstarted" href="/login"   rel="noreferrer">
            Get Started
          </a>

        </div>
      </header>
    </div>
  );
}

export default Header;